export default __webpack_public_path__ + "static/media/7.84f66b8f.svg";